/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * GTM events for Cashback Page
 *
 * @author Julia Ignatieva
 * @version 1.12.0
 * @since 1.12.0
 */

import { IGTMOperation } from './index';

export const clickOnInactiveTabCashbackPage = (tab: string): IGTMOperation => ({
    'event': 'addEvents_useNavigations',
    'event_id': 'd-v395-e4',
    'event_cat': 'Услуги за кешбэк / Tabs',
    'event_name': 'clickTabs',
    'event_param': tab,
});

export const clickOnPersonalAccountNumberCashbackPage = (accountNumber: string): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v395-e5',
    'event_cat': 'Услуги за кешбэк',
    'event_name': 'clickElement',
    'event_param': `Лицевой счет / ${accountNumber}`,
});

export const clickOnListsFiltersCashbackPage = (param: string): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v395-e6',
    'event_cat': 'Услуги за кешбэк / История операций',
    'event_name': 'clickElement',
    'event_param': param,
});

export const scrollCashbackControlPage = (param: number): IGTMOperation => ({
    'event': 'addEvents_useNavigations',
    'event_id': 'd-v395-e7',
    'event_cat': 'Услуги за кешбэк / Управление кешбэком / Scrolling',
    'event_name': 'Scroll',
    'event_param': `${param}%`,
});

export const clickOnLinksInCashbackPage = (tab: string, link: string): IGTMOperation => ({
    'event': 'addEvents_useNavigations',
    'event_id': 'd-v395-e8',
    'event_cat': `Услуги за кешбэк / ${tab}`,
    'event_name': 'clickElement',
    'event_param': `${tab} / ${link}`,
});

export const displayScoreReservedTooltip  = (): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v395-e10',
    'event_cat': 'Услуги за кешбэк / Управление кешбэком',
    'event_name': 'showElement',
    'event_param': 'Зарезервировано всего / Дополнительная информация',
});

export const clickOnInactiveTabCashbackControlTab = (tab: string): IGTMOperation => ({
    'event': 'addEvents_useNavigations',
    'event_id': 'd-v395-e11',
    'event_cat': 'Услуги за кешбэк / Управление кешбэком / Tabs',
    'event_name': 'clickTabs',
    'event_param': `Услуги за кешбэк / ${tab}`,
});

export const clickOnTileCashbackControlTab = (tab: string, tile: string): IGTMOperation => ({
    'event': 'addEvents_useNavigations',
    'event_id': 'd-v395-e12',
    'event_cat': 'Tiles / Услуги за кешбэк / Управление кешбэком',
    'event_name': 'clickTile',
    'event_param': `Услуги за кешбэк / ${tab} / ${tile}`,
});

export const clickOnTileElementCashbackControlTab = (tab: string, tile: string): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v395-e13',
    'event_cat': 'Услуги за кешбэк / Управление кешбэком',
    'event_name': 'clickElement',
    'event_param': `Услуги за кешбэк / ${tab} / ${tile} / Подробнее`,
});

export const useSliderCashbackControlTab = (isSliderEnabled: boolean): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v395-e14',
    'event_cat': 'Услуги за кешбэк / Управление кешбэком',
    'event_name': 'useSlider',
    'event_param': `Автоматическое распределение / ${isSliderEnabled ? 'Да' : 'Нет'}`,
});

export const clickOnButtonReserve = (isReserveButtonDisabled: boolean): IGTMOperation => ({
    'event': 'addEvents_makeConversions',
    'event_id': 'd-v395-e15',
    'event_cat': 'Услуги за кешбэк / Управление кешбэком',
    'event_name': 'submit',
    'event_param': `Зарезервировать / ${isReserveButtonDisabled ? 'Не активна' : 'Активна'}`,
});

export const openPopUpCashbackPage = (popup: string): IGTMOperation => ({
    'event': 'addEvents_makeConversions',
    'event_id': 'd-v395-e16',
    'event_cat': 'Услуги за кешбэк / Управление кешбэком',
    'event_name': 'checkOut1',
    'event_param': popup,
});

export const clickOnClosePopUpCashbackPage = (popup: string, isBackgroundClose: boolean): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v395-e17',
    'event_cat': 'Услуги за кешбэк / Управление кешбэком',
    'event_name': 'closePopUp',
    'event_param': `${popup} / ${(isBackgroundClose ? 'Внешний клик' : 'Крестик')}`,
});

export const clickOnReserveSuccess = (popup: string, isReserveAll: boolean): IGTMOperation => ({
    'event': 'addEvents_makeConversions',
    'event_id': 'd-v395-e18',
    'event_cat': 'Услуги за кешбэк / Управление кешбэком',
    'event_name': 'sendSuccess',
    'event_param': `${popup} / Зарезервировать / Зарезервировать весь кешбэк / ${(isReserveAll ? 'Да' : 'Нет')}`,
});

export const clickOnReserveAllCashback = (popup: string, isReserveAll: boolean): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v395-e19',
    'event_cat': 'Услуги за кешбэк / Управление кешбэком',
    'event_name': 'clickElement',
    'event_param': `${popup} / Зарезервировать весь кешбэк / ${(isReserveAll ? 'Да' : 'Нет')}`,
});

export const clickOnReserveModalSuccessButton = (popup: string): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v395-e20',
    'event_cat': 'Услуги за кешбэк / Управление кешбэком',
    'event_name': 'clickElement',
    'event_param': `${popup} / Хорошо`,
});

export const clickOnReserveFail = (popup: string, error: string): IGTMOperation => ({
    'event': 'addEvents_makeConversions',
    'event_id': 'd-v395-e21',
    'event_cat': 'Услуги за кешбэк / Управление кешбэком',
    'event_name': 'sendError',
    'event_param': `${popup} / ${error}`,
});
